<!-- 兑换记录 -->
<template>
  <div class="content">
    <div class="bodycontent">
      <div class="top">
        <div class="topLeft">
          <el-button
            v-for="(item, index) in optionData"
            :key="index"
            type="primary"
            :icon="item.icon"
            size="small"
            @click="go(item.value)"
          >
            {{ item.name }}
          </el-button>
        </div>
        <!-- <div style="display:flex;: center;align-items: center;">
          <el-select v-model="screenInput" placeholder="优惠券类型" size="mini">
            <el-option
              v-for="(item, index) in typeData"
              :label="item.name"
              :key="index"
              :value="item.index"
            ></el-option>
          </el-select>
        </div> -->
      </div>
      <div class="cont">
        <ul class="left">
          <li>类型</li>
          <li
            v-for="(item, index) in typeData"
            :key="index"
            @click="change(item.index)"
            :class="couponType == item.index ? 'current' : ''"
          >
            {{ item.name }}
          </li>
        </ul>
        <div class="right">
          <el-table
            :data="tableData"
            :header-cell-style="setHeader"
            height="100%"
            @selection-change="handleSelectionChange"
          >
            <!-- <el-table-column label="优惠券分享图">
              <template slot-scope="scope">
                <img
                  :src="scope.row.share_pic"
                  alt=""
                  style="width:50px; height: auto"
                />
              </template>
            </el-table-column> -->
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column prop="title" label="优惠券名称" width="120">
            </el-table-column>
            <el-table-column label="类型" width="85">
              <template slot-scope="scope">
                <div v-if="scope.row.type == 1">满减</div>
                <div v-if="scope.row.type == 2">折扣</div>
                <div v-if="scope.row.type == 3">代金</div>
                <div v-if="scope.row.type == 4">兑换</div>
                <div v-if="scope.row.type == 5">储值</div>
                <div v-if="scope.row.type == 6">通用</div>
                <div v-if="scope.row.type == 7">次数券</div>
              </template>
            </el-table-column>
            <el-table-column label="可领取时间">
              <template slot-scope="scope">
                {{ scope.row.get_start_time }} - {{ scope.row.get_end_time }}
              </template>
            </el-table-column>
            <el-table-column prop="valid" label="有效期"> </el-table-column>
            <el-table-column prop="user" label="可领取用户" width="85">
            </el-table-column>
            <el-table-column prop="stock" label="库存" width="55">
            </el-table-column>
            <el-table-column prop="exp" label="是否过期" width="85">
            </el-table-column>
            <el-table-column prop="isStop" label="优惠券状态" width="85">
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <div class="rowOption">
                  <el-button
                    v-for="(item, index) in rowOption"
                    size="mini"
                    :type="item.type"
                    @click="handle(item.value, scope.row)"
                    :key="index"
                  >
                    {{ item.name }}
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="page">
            <el-pagination
              @current-change="handleCurrentChange"
              layout="total, prev, pager, next, jumper"
              :total="total_num"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- 延期 -->
    <el-dialog
      title="延期"
      :visible.sync="showTime"
      @close="closePostPhone"
      width="580px"
    >
      <el-form ref="form" :model="postponeForm" label-width="80px">
        <!-- <el-form-item label="优惠券">
          <el-tag
            v-for="(item, index) in multipleSelection"
            :key="index"
            style="margin-right:10px"
          >
            {{ item.title }}
          </el-tag>
        </el-form-item> -->
        <el-form-item label="选择时间">
          <!-- <el-col :span="11">
            <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="postponeForm.date1"
              style="width: 100%;"
            ></el-date-picker>
          </el-col>
          <el-col :span="11">
            <el-time-picker
              placeholder="选择时间"
              v-model="postponeForm.date2"
              style="width: 100%;"
            ></el-time-picker>
          </el-col> -->
          <div>
            <el-radio
              v-model="postponeForm.is_term"
              label="0"
              :disabled="postponeForm.is_term == 1"
            >
              <span class="paddingRight8">固定时间</span>
              <el-date-picker
                class="marginRL"
                size="small"
                v-model="postponeForm.date1"
                value-format="yyyy-M-d"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :disabled="postponeForm.is_term == 1"
              >
              </el-date-picker>
            </el-radio>
          </div>
          <div>
            <el-radio
              v-model="postponeForm.is_term"
              label="1"
              :disabled="postponeForm.is_term == 0"
              >领取立即生效， <span>有效期:</span>
              <el-input
                v-model="postponeForm.date2"
                type="number"
                :disabled="postponeForm.is_term == 0"
                :min="0"
                size="small"
                @blur="
                  postponeForm.term_end_day = Number(
                    postponeForm.term_end_day
                  ).toFixed(0)
                "
                style="width: 80px"
              ></el-input>
              天
            </el-radio>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closePostPhone">取 消</el-button>
        <el-button type="primary" @click="confirmPostPhone">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { couponList, couponPostpone, couponShop, deletecoupon } from "@/api/coupon";
import { mapGetters } from "vuex";

export default {
  inject: ["reload"],
  computed: {
    ...mapGetters(["app_id", "token"])
  },
  data() {
    return {
      showTime: false,
      postponeForm: {
        is_term: "0",
        date1: [],
        date2: "",
        coupon_ids: ""
      },
      couponType: "0",
      total_num: 0,
      page: "",
      data: "",
      screenInput: "",
      headerStyle: {
        background: "rgba(250,250,250,1)",
        color: "#000000"
      },
      tableData: [],
      typeData: [
        {
          name: "全部",
          index: 0
        },
        {
          name: "满减",
          index: 1
        },
        {
          name: "折扣",
          index: 2
        },
        {
          name: "代金",
          index: 3
        },
        {
          name: "兑换",
          index: 4
        }
        // {
        //   name: "储值",
        //   index: 5optionData
        // },
        // {
        //   name: "通用",
        //   index: 6
        // },
        // {
        //   name: "次数券",
        //   index: 7
        // }
      ],
      optionData: [
        {
          name: "新增优惠券",
          value: "1",
          icon: "el-icon-plus"
        },
        {
          name: "领取记录",
          value: "3",
          icon: "el-icon-document"
        },
        {
          name: "核销记录",
          icon: "el-icon-tickets",
          value: "2"
        },
        // {
        //   name: "批量延期",
        //   icon: "el-icon-setting",
        //   value: "4"
        // },
        {
          name: "批量删除",
          icon: "el-icon-delete",
          value: "5"
        },
        {
          name: "批量暂停",
          icon: "el-icon-video-pause",
          value: "6"
        },
        {
          name: "批量开启",
          icon: "el-icon-video-play",
          value: "8"
        },
        {
          name: "赠送记录",
          icon: "el-icon-s-data",
          value: "7"
        }
      ],
      multipleSelection: [],
      rowOption: [
        {
          name: "复制",
          type: "",
          value: "3"
        },
        {
          name: "编辑",
          type: "success",
          value: "1"
        },
        {
          name: "延期",
          type: "",
          value: "4"
        },
        {
          name: "统计",
          type: "primary",
          value: "5"
        },
        {
          name: "删除",
          type: "danger",
          value: "0"
        }
      ]
    };
  },

  components: {},
  mounted() {
    this.getList();
  },
  methods: {
    // 暂停
    batchCoupon(status) {
      if (this.multipleSelection.length == 0) {
        this.$message.warning("请选择要操作的优惠券！！");
      } else {
        let ids = [];
        this.multipleSelection.forEach(item => {
          ids.push(item.id);
        });
        if (status == 4) {
          //  批量延期
          this.showTime = true;
        } else if (status == 5) {
          // 删除
          this.deleteTicks(ids.join(","));
        } else if (status == 6) {
          // 暂停1
          this.shop(1, ids.join(","));
        } else if (status == 8) {
          // 开启0
          this.shop(0, ids.join(","));
        }
      }
    },
    shop(is_stop, coupon_ids) {
      let data = {
        token: this.token,
        app_id: this.app_id,
        is_stop: is_stop,
        coupon_ids: coupon_ids,
        type: "0"
      };
      couponShop(data).then(res => {
        if (res.code == 200) {
          this.$message.success(res.msg);
        } else {
          this.$message.warning(res.msg);
        }
        console.log("暂停result", res);
        this.getList();
        // this.tableData = res.data.result;
      });
    },
    // 延迟弹窗
    closePostPhone() {
      this.showTime = false;
      this.postponeForm = {
        date1: [],
        date2: "",
        coupon_ids: "",
        is_term: "0"
      };
    },
    // couponPostpone
    confirmPostPhone() {
      // 延期
      let data = {
        token: this.token,
        app_id: this.app_id,
        is_term: this.postponeForm.is_term,
        coupon_ids: this.postponeForm.coupon_ids,
        day: this.postponeForm.date2,
        start_time: this.postponeForm.date1[0],
        end_time: this.postponeForm.date1[1]
      };
      couponPostpone(data).then(res => {
        if (res.code == 200) {
          this.$message.success(res.msg);
        } else {
          this.$message.warning(res.msg);
        }
        this.showTime = false;
        this.postponeForm = {
          date1: [],
          date2: "",
          coupon_ids: "",
          is_term: "0"
        };
        console.log("延期", res);
        this.getList();
        // this.tableData = res.data.result;
      });
    },
    //多选
    handleSelectionChange(val) {
      // this.multipleSelection = val;
      this.multipleSelection = val;
      console.log("数据多选，", val);
    },
    // 跳转
    go(type) {
      switch (type) {
        case "1":
          this.$router.push("optionTicket");
          break;
        case "2":
          this.$router.push("discounts");
          break;
        case "3":
          this.$router.push("grant");
          break;
        case "4":
          // 批量延期
          this.batchCoupon(4);
          break;
        case "5":
          // 批量刪除
          this.batchCoupon(5);
          break;
        case "6":
          // 批量暂停
          this.batchCoupon(6);
          break;
        case "8":
          // 批量开启
          this.batchCoupon(8);
          break;
        case "7":
          this.$router.push("statisticsCoupon");
          break;
      }
    },
    // change
    change(index) {
      this.couponType = index;
      this.getList();
    },
    // 设置表头颜色
    setHeader({ rowIndex }) {
      if (rowIndex === 0) {
        return this.headerStyle;
      } else {
        return "";
      }
    },
    // 筛选
    screen() {
      console.log("screenInput", this.screenInput);
      let data = {
        token: this.token,
        app_id: this.app_id,
        type: this.screenInput,
        store_id: 0 //
      };
      couponList(data).then(res => {
        console.log("订单列表", res);
        this.tableData = res.data.result;
      });
    },
    getList() {
      let data = {
        token: this.token,
        app_id: this.app_id,
        page: this.page,
        type: this.couponType //类型
        // is_exp: 0
      };
      couponList(data).then(res => {
        console.log("订单列表", res);
        this.tableData = res.data.result;
        this.total_num = res.data.total_num;
        // 处理数据
        var i = 0;
        for (i in this.tableData) {
          this.tableData[i].exp = this.tableData[i].is_exp
            ? "已过期"
            : "未过期";
          this.tableData[i].isStop =
            this.tableData[i].is_stop == 0 || this.tableData[i].is_stop == null
              ? "开启"
              : "暂停";
          this.tableData[i].valid = this.tableData[i].is_term
            ? `领取立即生效，有效期${this.tableData[i].term_end_day}天`
            : `${this.tableData[i].term_start_time} 至 ${this.tableData[i].term_end_time} `;
          // valid
          switch (this.tableData[i].user_limit) {
            case 0:
              this.tableData[i].user = "所有用户";
              break;
            case 1:
              this.tableData[i].user = "所有会员";
              break;
            case 2:
              this.tableData[i].user = "指定会员";
              break;
          }
        }
      });
    },
    // 操作 type 1 编辑 0 删除 index =>对应商品id
    handle(type, row) {
      if (type == 1) {
        this.$router.push({ name: "optionTicket", query: { idE: row.id } });
      } else if (type == 0) {
        this.deleteTicks(row.id);
      } else if (type == 3) {
        this.$router.push({
          name: "optionTicket",
          query: { idE: row.id, copyStatus: true }
        });
      } else if (type == 4) {
        if (row.is_term == 0) {
          this.postponeForm.date1 = [];
          this.postponeForm.date1.push(row.term_start_time.split(" ")[0]);
          this.postponeForm.date1.push(row.term_end_time.split(" ")[0]);
        } else {
          this.postponeForm.date2 = row.term_end_day;
        }
        this.postponeForm.is_term = String(row.is_term);
        this.postponeForm.coupon_ids = String(row.id);
        this.showTime = true;
        // term_end_time
      } else if (type == 5) {
        this.$router.push({
          name: "grant",
          query: { couponId: row.id }
        });
      }
    },
    deleteTicks(ids) {
      let data = {
        token: this.token,
        app_id: this.app_id,
        store_id: 0, //
        id: ids
      };
      this.$confirm("删除是不可逆的，请谨慎删除?！！！", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deletecoupon(data).then(res => {
            console.log("shanchu ", res);
            if (res.code == 200) {
              this.$message.success(res.msg);
              this.reload();
            } else {
              this.$message("删除失败");
            }
          });
          this.getList();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getList();
    }
  }
};
</script>
<style lang="scss" scoped>
.flex {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.padding {
  padding: 20px;
}
.content {
  // width: 100%;
  height: 100%;
  padding: 0 55px 30px 30px;

  .bodycontent {
    height: 100%;
    .top {
      min-height: 60px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .topLeft {
        height: auto;
        .el-button {
          margin: 0 10px 10px 0;
        }
      }
    }
    .cont {
      width: 100%;
      height: calc(100% - 60px);
      display: flex;
      .left {
        width: 140px;
        margin-right: 15px;
        border: 1px solid #ebeef5;
        li {
          width: 100%;
          line-height: 50px;
          padding: 0 15px;
          border-bottom: 1px solid #ebeef5;
          cursor: pointer;
        }
        li:first-child {
          background: #fafafa;
        }
        .current {
          background: #fafafa;
        }
      }
      .right {
        flex: 1;
        display: flex;
        overflow: hidden;
        flex-direction: column;
        .page {
          height: 50px;
          display: flex;
          align-items: center;
        }
        .el-table {
          flex: 1;
          overflow-y: autro;
          //table操作按钮
          .rowOption {
            .el-button {
              margin: 0 10px 10px 0;
            }
          }
        }
      }
    }
  }
}
</style>
